import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";

// Formato de etiqueta elegido por el admin (config/app.etiquetaFormato).
//   "doble" = dos etiquetas 7×4  ·  "unica" = una etiqueta 10×5
// Default "doble" (todavía hay stock de las chicas). Listener en vivo.
export function useEtiquetaFormato() {
  const [formato, setFormato] = useState("doble");
  useEffect(() => {
    const unsub = onSnapshot(
      doc(db, "config", "app"),
      (snap) => setFormato(snap.exists() && snap.data().etiquetaFormato === "unica" ? "unica" : "doble"),
      () => setFormato("doble")
    );
    return () => unsub();
  }, []);
  return formato;
}
